import { useState, useEffect, useRef } from 'react';
import {typeOptions, alignmentOptions, sizeOptions, bookOptions, spellCastingOptions,
    shuffledMonsterList, shuffleArray, sortedMonsterList,
    reversedMonsterList, generateUniqueId, exportSpells,
    exportSpellsShuffled, allConditions, allConditionsShuffled, adventureNamesExport,
    getImageUrl,
    sortBookNames
} from '../../constants'
import { InfinitySpin, ThreeDots } from 'react-loader-spinner'
import StatBlock from '../Statblock/StatBlock';
import StatBlockPdf from '../Statblock/PDF/StatBlockPdf';
import OptionButton from '../EncounterColumn/OptionButton';
import Refresh from '../../pics/icons/refresh.png'
import Asort from '../../pics/icons/Asort.PNG'
import Zsort from '../../pics/icons/Zsort.PNG'
import SearchTab from './SearchTab';
import Filters from './Filters';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { useImportedPlayers } from '../../../../../providers/ImportedPlayersProvider';
import { useHomebrewProvider } from '../../../../../providers/HomebrewProvider';
import InputCharacterId from '../SideMenu/InputCharacterId';
import InputEncounterId from '../SideMenu/InputEncounterId';
import magPlus from '../../pics/icons/magPlus.PNG'
import RemoveFilter from '../../pics/icons/deleteFilter.png'
import SearchOptionsDropdown from './SearchOptionsDropdown'
import 'react-range-slider-input/dist/style.css';
import Slider from '@mui/material/Slider';
import ImportHtml from './ImportHtml';
import { isProd } from '../../constants';

const titles = ["Monster Search", "Homebrew", "DndBeyond Imports", "Spells", "Conditions", "Books"];
const noMoreLabels = ["Monsters", "Homebrewed Creatures", "DndBeyond Imports", "Spells", "Conditions", "Books"];
const searchInputLabels = [
    "Search by Name, Campaign or Character ID",
    "Search by Name, Campaign or Character ID",
    "Search by Creature Name...",
    "Search by Spell Name...",
    "Search by Condition Name or Type...",
    "Search by Book Title..."
];

const TAB_COUNT = 6
const panels = Array(TAB_COUNT).fill(null);
const errorMessages = {
    1: "Encounter IDs should only contain letters, numbers and dashes",
    2: "Improper Encounter ID format. See 'Import Help' below",
    3: "Only numbers are allowed (and commas for a list of IDs)",
}


const SearchColumn = ({showSearchList, setCurrentEncounter, encounterGuid, handleUploadMonsterImage, uploadIconCreature, setShowSearchList, searchSelectedCreature, setSearchSelectedCreature, addNewHomebrew, pdfBuilder, socket}) => {
    const defaultDisplayNumber = 20;
    const {importedPlayers} = useImportedPlayers();
    const {homebrewList} = useHomebrewProvider();
    // this is used to keep track of the fetch id so that we can cancel the previous fetch if a new one is made
    const fetchIdRef = useRef(0); 

    const [searchTerm, setSearchTerm] = useState('');
    const [sortType, setSortType] = useState('shuffle');
    const [tabSelectedIndex, setTabSelectedIndex] = useState(0);
    const [searchSelectedEncounter, setSearchSelectedEncounter] = useState({encounterName: "search", creatures: []});
    const [pinnedCount, setPinnedCount] = useState(0);

    const [filterType, setFilterType] = useState([]);
    const [filterSource, setFilterSource] = useState([]);
    const [filterAlignment, setFilterAlignment] = useState([]);
    const [filterSize, setFilterSize] = useState([]);
    const [filterCrRange, setFilterCrRange] = useState([0,30]);
    const [filterSpellcasting, setFilterSpellcasting] = useState([]);

    const [listSize, setlistSize] = useState(defaultDisplayNumber);

    const [numberOfListItems, setNumberOfListItems] = useState(defaultDisplayNumber);
    const [lowerListLoading, setLowerListLoading] = useState(false);
    const [loadedAllMessage, setLoadedAllMessage] = useState(false);
    const [displayedItems, setDisplayedItems] = useState([]);

    const [loading, setLoading] = useState(true);
    const [backgroundLoading, setBackgroundLoading] = useState(true);
    const [filtersOpen, setFiltersOpen] = useState(false);
    const [backendReady, setBackendReady] = useState(true);

    const [error, setError] = useState(null);

    useEffect(() => {
        if(error) {
            setTimeout(() => {
                setError(null)
            }, 15000)
        }
    }, [error]);

    useEffect(() => {
        if(uploadIconCreature && uploadIconCreature.column === 'search') {
            setSearchSelectedCreature(uploadIconCreature)
        }
    }, [uploadIconCreature]);

    useEffect(() => {
        if(searchSelectedCreature) {
            homebrewList.forEach(creature => {
                if (searchSelectedCreature.dmb_homebrew_guid === creature.dmb_homebrew_guid || searchSelectedCreature.creatureGuid === creature.creatureGuid) {
                    setSearchSelectedCreature(creature)
                }
            });
        }
    }, [homebrewList]);

    useEffect(() => { 
        if(searchSelectedCreature) {
            let encounterName = searchSelectedCreature.name_default === "Homebrew-Template-DmBuddy" ? 'dmbuddy_newhomebrew' : 'dmbuddy_selected'
            let searchEncounter = {encounterName: encounterName, creatures: [{...searchSelectedCreature, creatureGuid: searchSelectedCreature.creatureGuid ?? generateUniqueId()}]}
            setSearchSelectedEncounter(searchEncounter)
        } else {
            setSearchSelectedEncounter(null)
        }
    }, [searchSelectedCreature]);
    
    useEffect(() => {
        if(backendReady && (loading || backgroundLoading || lowerListLoading)) {
            fetchIdRef.current += 1;
            const fetchId = fetchIdRef.current;

            async function fetchData() {
                let list;
                if(tabSelectedIndex === 0) {
                    if(sortType === "shuffle" || sortType === "reshuffle") {
                        list = shuffledMonsterList;
                    } else if(sortType === 'A') {
                        list = sortedMonsterList;
                    } else if(sortType === 'Z') {
                        list = reversedMonsterList;
                    }
                } else if (tabSelectedIndex === 1) {
                    list = homebrewList;
                } else if (tabSelectedIndex === 2) {
                    const sortedByCampaign = [...importedPlayers].sort((a, b) => {
                        const campaignA = a.campaign || ""; 
                        const campaignB = b.campaign || "";
                        return campaignA.localeCompare(campaignB);
                    });
                    list = sortedByCampaign;
                } else if (tabSelectedIndex === 3) {
                    if (sortType === "shuffle" || sortType === "reshuffle") {
                        list = exportSpellsShuffled;
                    } else if (sortType === "A") {
                        list = [...exportSpells].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                    } else if (sortType === "Z") {
                        list = [...exportSpells].sort((a, b) => (b.name || '').localeCompare(a.name || ''));
                    }
                } else if (tabSelectedIndex === 4) {
                    if (sortType === "shuffle" || sortType === "reshuffle") {
                        list = allConditionsShuffled;
                    } else if (sortType === "A") {
                        list = [...allConditions].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                    } else if (sortType === "Z") {
                        list = [...allConditions].sort((a, b) => (b.name || '').localeCompare(a.name || ''));
                    }
                } else if (tabSelectedIndex === 5) {
                    list = sortBookNames(adventureNamesExport)
                }

                let filtered = list;
                let isCrDefaultRange = filterCrRange[0] === 0 && filterCrRange[1] === 30;
                filtered = list.filter(item => {

                    const tabMatches = (filterArr, sVal) => filterArr.length === 0 || filterArr.some(filter => (filter || '').toLowerCase().includes(sVal.toLowerCase()));
                    const inputMatch = tabMatches([
                            item?.name, // all 
                            item?.objectType, // conditions
                            item?.dnd_b_player_id, item?.campaign // dndb imports
                        ], searchTerm.toLowerCase())

                    // These tabs do not need additional filtering
                    if([2,3,4,5].includes(tabSelectedIndex)) {
                        return inputMatch;
                    }

                    // Helper for filter matching
                    const matches = (filterArr, val) => filterArr.length === 0 || filterArr.some(filter => (val || '').toLowerCase().includes(filter.toLowerCase()));
                  
                    let filterMatch =
                        matches(filterSource, item?.sourceShort) &&
                        matches(filterAlignment, item?.creature_alignment) &&
                        matches(filterSize, item?.size) &&
                        matches(filterType, item?.creature_type);

                    // Spellcasting filter is either 'Spellcasting' or 'No Spellcasting'
                    if(filterSpellcasting.length === 1) {
                        filterMatch = (
                            (filterSpellcasting[0] === 'Spellcasting' && item.spellcasting.length > 0) || 
                            (filterSpellcasting[0] === 'No Spellcasting' && item.spellcasting.length === 0)
                        ) && filterMatch; // Retain filterMatch if already true
                        
                    }
                        
                    // CR filter
                    if (!(filterCrRange[0] === 0 && filterCrRange[1] === 30)) {
                        let CR = item?.cr ?? item?.challenge_rating;
                        if(typeof CR === 'string' && CR.includes('/')) {
                            var split = CR.split('/');
                            CR = parseInt(split[0], 10) / parseInt(split[1], 10);
                        }
                        const isCrRange = CR >= filterCrRange[0] && CR <= filterCrRange[1];
                        filterMatch = isCrRange && filterMatch;
                    }

                    return inputMatch && filterMatch;
                })
                .sort((a, b) => {
                    if(tabSelectedIndex < 3) {
                        if (!isCrDefaultRange) {
                            let aCR = a?.cr || a?.challenge_rating || 0
                            let bCR = b?.cr || b?.challenge_rating || 0
                            return aCR - bCR;
                        }
                        return 0;
                    } else if(searchTerm) {
                        return (a.name || '').localeCompare(b.name || '');
                    }
                });

                setlistSize(filtered.length)
                filtered = filtered.slice(0, numberOfListItems);

                // Homebrew and Import do not need avatarUrls because they come from the Dmb database
                if(tabSelectedIndex === 0) {
                    const promises = filtered.map(async creature => {
                        let avatarUrl = await getImageUrl(creature.name, creature.creature_type)
                        return {...creature, avatarUrl}
                    });

                    filtered = await Promise.all(promises);
                }
                
                if (fetchId === fetchIdRef.current) {
                    setDisplayedItems(filtered);
                    setLoading(false)
                    setLowerListLoading(false)
                    setBackgroundLoading(false)
                } else {
                    console.log(`Skipped filter update.`);
                }
            }

            const timeoutId = setTimeout(() => {
                fetchData();
            }, (backgroundLoading || lowerListLoading) ? 0 : 500); 

            return () => {
                clearTimeout(timeoutId);
            } 
        }
    
    }, [loading, lowerListLoading, backgroundLoading, backendReady, searchTerm, filterCrRange, filterSize, filterSource, filterType, filterSpellcasting, tabSelectedIndex]);

    useEffect(() => {
        if(socket) {
            // Emit room ID to the server after connection is established
            socket.on('backendready', () => {
                console.log(`Backend Ready FetchingData`);
                setBackendReady(true)
            });
        }
    }, [socket])

    useEffect(() => {
        if(!loading) {
            setLoading(true)
        }

        setLoadedAllMessage(false)
    }, [searchTerm, sortType, filterAlignment, filterSize, filterSource, filterType, filterCrRange, filterSpellcasting, tabSelectedIndex])
    
    // Force an update when pinned count changes to resort 
    useEffect(() => {
        setDisplayedItems(prev => sortBookNames([...prev]))
    }, [pinnedCount])

    useEffect(() => {
        if(!backgroundLoading)
            setBackgroundLoading(true)
    }, [importedPlayers, homebrewList])

    const shuffleSearchList = () => {
        // This shuffle the shuffledMonsterList and then inside the useeffect it is set to displayedItems
        if(tabSelectedIndex === 0) shuffleArray(shuffledMonsterList)
        else if(tabSelectedIndex === 3) shuffleArray(exportSpellsShuffled)
        setSortType(prev => prev === 'shuffle' ? 'reshuffle' : 'shuffle')
    }

    const sortSearchList = () => {
        if(sortType === "A") {
            setSortType('Z')
        } else {
            setSortType('A')
        }
    }

    const handleSetSearchTerm = (term) => {
        setSearchTerm(term)
    };

    
    // Set the number of list items to 10 more when hit the limit
    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop - (clientHeight/4) <= clientHeight) {
            setNumberOfListItems(loading ? displayedItems.length : displayedItems.length+defaultDisplayNumber);
            
            if(displayedItems.length === listSize) {
                setLoadedAllMessage(true) 
            } else {
                setLowerListLoading(true)
            }
        }
    };

    const handleTabSelect = (index) => {
        if(index !== tabSelectedIndex) {
            setLoading(true)
            setTabSelectedIndex(index)
            setSearchTerm("")
            setNumberOfListItems(defaultDisplayNumber)

            if(index > 1) {
                setFiltersOpen(false)
            }
        }
    }

    let sortMessage = sortType === "shuffle" || sortType === "reshuffle" || sortType === "Z" ? "Sort A-Z" : "Sort Z-A"
    let showStatBlock = (searchSelectedCreature && searchSelectedEncounter?.creatures.length > 0)

    let widthType = ''; 
    if(!showStatBlock) {
        widthType = '45%'
    }

    const clearFilters = () => {
        setFilterSpellcasting([])
        setFilterType([])
        setFilterSize([])
        setFilterAlignment([])
        setFilterSource([])
        handleCrRange(null, [0,30])
        setSearchTerm("")
    }

    useEffect(() => {
        const thumbs = document.querySelectorAll('.MuiSlider-thumb');
        if (thumbs.length === 2) {
            // Get the X value of each thumb
            const thumb0X = thumbs[0].getBoundingClientRect().x; // X position of the first thumb
            const thumb1X = thumbs[1].getBoundingClientRect().x; // X position of the second thumb

            if(thumb0X < thumb1X) {
                thumbs[0].setAttribute('data-value', filterCrRange[0]);
                thumbs[1].setAttribute('data-value', filterCrRange[1]);
            } else {
                thumbs[1].setAttribute('data-value', filterCrRange[0]);
                thumbs[0].setAttribute('data-value', filterCrRange[1]);
            }
        }

    }, [filterCrRange, filtersOpen])

    const returnFilters = () => {
        const filterComponents = [];
        if (filterSize.length === 1)         filterComponents.push(<span key="size"><b>{filterSize[0]}</b></span>);
        if (filterAlignment.length === 1)    filterComponents.push(<span key="alignment"><b>{filterAlignment[0]}</b></span>);
        if (filterType.length === 1)         filterComponents.push(<span key="type"><b>{filterType[0]}</b></span>);
        if (filterSource.length === 1)       filterComponents.push(<span key="source">from <b>{filterSource[0]}</b></span>);
        if (filterSpellcasting.length === 1) filterComponents.push(<span key="spells">with <b>{filterSpellcasting[0]}</b></span>);

        if (filterSize.length > 1)       filterComponents.push(<span key="size"><b>Size ({filterSize.length})</b></span>);
        if (filterAlignment.length > 1)  filterComponents.push(<span key="alignment"><b>Alignment ({filterAlignment.length})</b></span>);
        if (filterType.length > 1)       filterComponents.push(<span key="type"><b>Type ({filterType.length})</b></span>);
        if (filterSource.length > 1)     filterComponents.push(<span key="source"><b>Sorce ({filterSource.length})</b></span>);
        if (filterSpellcasting.length > 1)     filterComponents.push(<span key="spells"><b>Spells ({filterSpellcasting.length})</b></span>);

        if (filterCrRange[0] !== 0 || filterCrRange[1] !== 30) {
            filterComponents.push(
                <span key="cr">
                    between CR <b>{filterCrRange[0]}</b> and <b>{filterCrRange[1]}</b>{' '}
                </span>
            );
        }

        //Add commas
        const interleaved = filterComponents.reduce((acc, el, idx) => {
            if (idx > 0) 
                acc.push(<span key={idx}>, </span>);
            acc.push(el);
            return acc;
        }, []);

        return filterComponents.length
            ? <i>Filters applied: <span className='infoDesc'>{interleaved}</span></i>
            : null;
    };

    let filterString = returnFilters()

    const handleCrRange = (e, newRange) => {
        setFilterCrRange([...newRange]);
    };

    let monsterListHeight = tabSelectedIndex === 2 ? '70.4%' : (filterString ? '76%' : '79%')

    if(showSearchList) {
        return (
            <>
                {!pdfBuilder &&
                    <div className='searchColumn' style={{width: widthType}}>
                        <div className='infoContainer' style={{borderRadius: '0', backgroundColor: '#ddd7ba'}}>
                            <button className='searchColumnX' onClick={() => setShowSearchList(false)}>❌</button>
                            <Tabs onSelect={(index) => handleTabSelect(index)}>
                                <TabList>
                                    <Tab>Search</Tab>
                                    <Tab>Homebrew</Tab>
                                    <Tab>DndBeyond</Tab>
                                    <Tab>Spells</Tab>
                                    <Tab>Conditions</Tab>
                                    <Tab>Books</Tab>
                                </TabList>

                                <h3 className='titleFontFamily' style={{borderBottom: '1px solid #822000'}}>{titles[tabSelectedIndex]}</h3>
                                {tabSelectedIndex === 2 && 
                                    <div className='importInputsContainer'>
                                        <div className='importInputs editHpGrow'>
                                            <InputCharacterId setCurrentEncounter={setCurrentEncounter} encounterGuid={encounterGuid} setError={setError} socket={socket} />
                                            <InputEncounterId setCurrentEncounter={setCurrentEncounter} encounterGuid={encounterGuid} setError={setError} socket={socket} />
                                        </div>
                                        {error &&
                                            <> 
                                                <div style={{color: '#cb0000'}}><b><i>{errorMessages[error]}</i></b></div>
                                                <hr className="seperator"/>
                                            </>
                                        }
                                        <details>
                                            <summary><b>Import Help</b></summary>
                                            <div className='importErrorContainer'>
                                                <ul className='howToImportList'>
                                                    <li className='importErrorMsg'>Character and Encounters ID's can be found in your DndBeyond Url i.e.</li>
                                                    <ul>
                                                        <li className='importErrorMsgLink'>Character ID - <i>https://www.dndbeyond.com/characters/</i><b>44429861</b></li>
                                                        <li className='importErrorMsgLink'>Encounter ID - <i>https://www.dndbeyond.com/encounters/</i><b>ed9784fc-5aba-473a-9ae9-166fed396e8e</b></li>
                                                        <li className='importErrorMsgLink'>Homebrew ID - <i>https://www.dndbeyond.com/monsters/</i><b>6299511</b>-medic (just the numbers)</li>
                                                    </ul>
                                                    <li className='importErrorMsg'>DmBuddy will try to import all PC's in the same campaign as the imported players</li>
                                                    <li className='importErrorMsg'>Import multiple players with a comma seperated list i.e. <b>12345678,9817263,19203912</b></li>
                                                    <li className='importErrorMsg'>Join <a className='' href='https://discord.gg/26TWEMqdka'>DmBuddy's Discord</a> and I'll help ya</li>
                                                </ul>
                                                
                                            </div>
                                        </details>
                                        {!isProd && 
                                            <details>
                                                <summary><b>Import HTML</b></summary>
                                                <ImportHtml setCurrentEncounter={setCurrentEncounter} encounterGuid={encounterGuid} socket={socket}/>
                                            </details>
                                        }
                                    </div>
                                }
                                
                                <div className='encounterControlsContainer'>
                                    <div className='searchInputFlex'>
                                        <input
                                            className='searchBar'
                                            type="text"
                                            placeholder={searchInputLabels[tabSelectedIndex]}
                                            value={searchTerm}
                                            onChange={(e) => handleSetSearchTerm(e.target.value)}
                                        />
                                        <OptionButton src={magPlus} message={'Create New Homebrew'} onClickFunction={addNewHomebrew} wrapperClassName='searchListOption'/>
                                        {(tabSelectedIndex !== 1 && tabSelectedIndex !== 2 && tabSelectedIndex !== 5) && 
                                            <>
                                                <OptionButton src={sortType === "shuffle" || sortType === "reshuffle" || sortType === "Z" ? Asort : Zsort} message={sortMessage} onClickFunction={sortSearchList} wrapperClassName='searchListOption'/>
                                                <OptionButton src={Refresh} message={'Shuffle List'} onClickFunction={shuffleSearchList} wrapperClassName='searchListOption'/>
                                            </>
                                        }
                                    
                                    
                                    </div>
                                    {tabSelectedIndex < 2 &&
                                        <>
                                            <Filters filterType={filterType} setFilterType={setFilterType} filterSource={filterSource} setFilterSource={setFilterSource} filterAlignment={filterAlignment} setFilterAlignment={setFilterAlignment} filterSize={filterSize} setFilterSize={setFilterSize} filterCrRange={filterCrRange} setFilterCrRange={setFilterCrRange} filterSpellcasting={filterSpellcasting} setFilterSpellcasting={setFilterSpellcasting} filtersOpen={filtersOpen} setFiltersOpen={setFiltersOpen}/>
                                            {(filterString !== null || searchTerm !== "") && 
                                                <div style={{ display: 'inline'}}>
                                                    {filterString}                                             
                                                    <OptionButton src={RemoveFilter} message={"Clear Filters"} onClickFunction={clearFilters} wrapperClassName='filterClearOption' imgStyle={{margin: 0}}/>
                                                </div>
                                            }
                                        </>
                                    }
                                    <div style={{display: "inline"}}>
                                        {tabSelectedIndex !== 5 && tabSelectedIndex !== 2 && sortType.includes('shuffle') && filterString === null && 'Random '} {noMoreLabels[tabSelectedIndex]} Load{loading ? <>ing...</> : <>ed: <span className='infoDesc'> {displayedItems.length}</span> </>}
                                    </div>
                                </div>
                                {loading ? (
                                    <>
                                        {panels.map((_, index) => (
                                            <TabPanel key={titles[index] + "spinner"}>
                                                <div className='listItemLoadingContainer listItemLoadingInfinity'>
                                                    <InfinitySpin visible={true} width="200" color="#822000" ariaLabel="infinity-spin-loading" />     
                                                </div>                 
                                            </TabPanel>
                                        ))}
                                    </>
                                ) : ( 
                                    <div className='monsterSearch' style={{height: monsterListHeight }} onScroll={handleScroll}>
                                        <ul className='monsterSearchList'>
                                            {panels.map((_, index) => (
                                                <TabPanel key={titles[index]}>
                                                    <SearchTab tabSelectedIndex={tabSelectedIndex} displayedItems={displayedItems} setCurrentEncounter={setCurrentEncounter} encounterGuid={encounterGuid} searchTerm={searchTerm} setSearchSelectedCreature={setSearchSelectedCreature} setPinnedCount={setPinnedCount} socket={socket} />
                                                    {lowerListLoading && 
                                                        <div className='listItemLoadingContainer'>
                                                            <li className='listItemLoading loadingMorePopUp'>
                                                                <span style={{color: "black"}}><i>Finding More {noMoreLabels[tabSelectedIndex]}...</i></span>
                                                                <ThreeDots
                                                                    visible={true}
                                                                    height="20"
                                                                    width="50"
                                                                    color="#822000"
                                                                    radius="1"
                                                                    ariaLabel="three-dots-loading"
                                                                />
                                                            </li>
                                                        </div>
                                                    }
                                                    {loadedAllMessage && 
                                                        <div className='listItemLoadingContainer'>
                                                            <li className='listItemLoading loadingMorePopUp'>
                                                                <span style={{color: "black"}}><i>Found All {noMoreLabels[tabSelectedIndex]}!</i></span>
                                                            </li>
                                                        </div>
                                                    }
                                                </TabPanel>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </Tabs>
                        </div>
                    </div>
                }
                {!showStatBlock && pdfBuilder && 
                    <div className='playerViewTimeoutContainer grow'>
                        <div className='titleFontFamily'><b>Open a Creatures Statblock from the Search Column first</b></div>
                    </div>
                }

                {showStatBlock && 
                    <div className={'column grow'} style={{flex: pdfBuilder ? 'auto' : '.8', border: pdfBuilder ? 'none' : '2px solid #7f7977'}}>
                        <div className='statBlock'>
                            {pdfBuilder ?
                                <StatBlockPdf selectedIndex={0} currentEncounter={searchSelectedEncounter} setCurrentEncounter={setSearchSelectedEncounter} closeStatBlock={() => setSearchSelectedCreature(null)} handleUploadMonsterImage={handleUploadMonsterImage} pdf={pdfBuilder}/>
                            :
                                <StatBlock selectedIndex={0} currentEncounter={searchSelectedEncounter} setCurrentEncounter={setSearchSelectedEncounter} closeStatBlock={() => setSearchSelectedCreature(null)} handleUploadMonsterImage={handleUploadMonsterImage} pdf={pdfBuilder}/>
                            }
                        </div>
                    </div>
                }
            </>
        );
    }
}

export default SearchColumn;